<section id="campaign-table">
    <h3>My Thrift Logs</h3>
    <div class="container" style="overflow:scroll; height: 30vh;">
       
        <table class="styled-table" >
            <thead>
                <tr>
                    <th>S/N</th>
                    <th>Name</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Creation Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>The Oyebola Dynasty</td>
                    <td>2 Weeks</td>
                    <td>Running</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Gateway CDA</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
                <tr class="active-row">
                    <td>1</td>
                    <td>Simeon</td>
                    <td>2 Weeks</td>
                    <td>Ended</td>
                    <td>Wed 05, 2022</td>
                    <td><a href="#" class="view-campaign">View</a></td>
                </tr>
            </tbody>
        </table>


    </div>
</section>